import MxAutoCompleteField from "@rf-l1/form/selects/MxAutoCompleteField/MxAutoCompleteField";
import { MxAutoCompleteFieldProps } from "@rf-l1/form/selects/MxAutoCompleteField/model/MxAutoCompleteField";
import { useMxFieldControllerContext } from "@/src-refactor/modules/shared/components/refactor/context/MxFieldController";
import { A_BUSINESS_DETAILS } from "@/src-refactor/modules/shared/model/const/property/bussines-detail";

type omit = "value" | "id" | "name" | "testId" | "items" | "onChange";
interface MxFormSelectBusinessDetailTypeFieldProps
  extends Omit<MxAutoCompleteFieldProps, omit> {
  onlySale?: boolean;
}
const MxFormSelectBusinessDetailTypeField = (
  props: MxFormSelectBusinessDetailTypeFieldProps
) => {
  const { onChange, onBlur, name, value, invalid, id, testId } =
    useMxFieldControllerContext();
  const { onlySale, ...rest } = props;

  return (
    <MxAutoCompleteField
      {...rest}
      items={A_BUSINESS_DETAILS}
      id={id}
      testId={testId}
      onChange={onChange}
      onBlur={onBlur}
      name={name}
      value={value}
      error={invalid}
    />
  );
};

export default MxFormSelectBusinessDetailTypeField;
